<template>
    
    <!--Header-->
    <Header  
        :menuTop="(isLoggedIn) ? menuLeft('leftAuth') : menuLeft('left')"
        :menuPersonal="menuPersonal"
        :menuMob="(isLoggedIn) ? menuLeft('mobAuth') : menuLeft('mob')"/>

    <!--Content-->
    <div class="flex flex--content surface-100">
        <div class="w-full border-noround">
            <!--Content start -->
            <router-view />
            <Toast />
            <!--Content end -->
        </div>
    </div>
    
    <!-- Footer -->
    <Footer :loading="loadAuth" :menu="menuLeft('bottom')"/>

    <!-- Popups -->
    <Popups />

    <!-- Calc screen size -->
    <div v-if="!screen_size" class="hidden">{{ screen_size }}</div>

    <noscript v-if="vue_mode=='production'"><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=853657576289627&ev=PageView&noscript=1"/></noscript>
    <noscript v-if="vue_mode=='production'"><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1490390608431679&ev=PageView&noscript=1"/></noscript>
    <noscript v-if="vue_mode=='development'"><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=598723432604070&ev=PageView&noscript=1"/></noscript>
</template>


<script setup>
    import { onMounted } from 'vue'

    // проверяем на visitorId в localstorage
    let visitorId = ''
    const visitorId_localstorage = localStorage.getItem('visitorId')
    if(visitorId_localstorage){
        visitorId = visitorId_localstorage
    }
    const isTgApp = (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) ? true : false

    const isPWA = (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) ? true : false

    try{
        window.Telegram.WebApp.onEvent('viewportChanged', () => {
            window.Telegram.WebApp.expand();
        });
    } catch(e){}

    if(process.env.NODE_ENV=='production' || process.env.NODE_ENV=='preprod'){
            
        window.BrevoConversationsSetup = {
            startHidden: (isTgApp || isPWA) ? true : false,
            // startHidden: true,
            language: 'ru',
            colors: {
                buttonText: '#5e7e4a',
                buttonBg: '#aeee83'
            },
            buttonSize: 50,
            visitorId: visitorId, 
        };
    
        // BREVO CHAT
        (function(d, w, c) {w.SibConversationsID = '642028bd498fcf502f17a1fb';w[c] = w[c] || function() {(w[c].q = w[c].q || []).push(arguments);};var s = d.createElement('script');s.async = true;s.src = 'https://conversations-widget.sendinblue.com/sib-conversations.js';if (d.head) d.head.appendChild(s);})(document, window, 'SibConversations');
    }


    // Получение Pixel ID из переменных окружения
    const fbPixelId = (process.env.VUE_APP_FB_PIXEL_ID) ? process.env.VUE_APP_FB_PIXEL_ID : null

    onMounted(() => {
        if (fbPixelId) {
            !function(f,b,e,v,n,t,s) {
            if(f.fbq)return; n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n; n.push=n; n.loaded=!0; n.version='2.0';
            n.queue=[]; t=b.createElement(e); t.async=!0;
            t.src=v; s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)
            }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js')

            fbq('init', fbPixelId)
            fbq('track', 'PageView')
        } else {
            console.warn('FB Pixel ID не задан в переменных окружения.')
        }
    })
</script>

<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import Event from '@/assets/js/Event'

import Header from '@/components/sides/Header.vue'
import Footer from '@/components/sides/Footer.vue'
import Popups from '@/components/sides/Popups.vue'

import { PaymentSystemList, BankList } from '@/assets/js/classes/PaymentSystem.js'
import { RecipientList } from '@/assets/js/classes/Recipient.js'
import { CurrencyList} from '@/assets/js/classes/Currency.js'
import TelegramAnalytics from '@telegram-apps/analytics'
import { createI18n } from "vue-i18n";
import { PrimeIcons } from '@primevue/core/api';
import { useRoute } from 'vue-router'
import lang from './lang';
import { useCookies } from "vue3-cookies"
import '@/assets/css/less/module.less'
import { mapActions } from "vuex"
import { ref } from 'vue'

export default {
    name: 'App',
    data() {
        return {
            local: (this.$store.getters.StateLang) ? this.$store.getters.StateLang : (this.$i18n.locale) ? this.$i18n.locale : 'ru',
            window: {
                width: 0,
                height: 0
            },
            route: useRoute(),
            cookies: useCookies(),
            isWebAppTg: false,
            initData: null,
            initDataUnsafe: null,
            loadAuth: false,
            vue_mode: null,
        }
    },
    components: {
        Header,
        Footer,
        Popups
    },
    watch: {
        initData: async function (val) {
            if(!val) return
            this.isWebAppTg = (val) ? true : false

            if(val) {
                try{
                    await this.$store.dispatch('setTgApp', true).then(() => {})
                } catch {}
            }
        }
    },
    computed: {
        isWebAppTg() {
            return (this.initData) ? true : false
        },
        screen_size() {
            const screen_size = this.helper.screen_size(this)
            this.$store.dispatch('setScreenSize', screen_size)
            return screen_size
        },
        isLoggedIn: function () { return this.$store.getters.isAuthenticated },
        menuLeftAdm() {
            let raw_menu = this.menuLeftDyn(),
                out_menu = []

            raw_menu.forEach(el => {
                try {
                    let menu_type = el.menu_type
                    if (menu_type.includes("admin") && this.isUserInGroup('admin')) out_menu.push(el)
                } catch { }
            })

            //сортируем меню
            out_menu.sort(function (a, b) {
                return a.sort - b.sort
            })

            return out_menu
        },
        menuPersonal() {
            let raw_menu = this.menuLeftDyn(),
                out_menu = [], type

            if (this.isLoggedIn) {
                type = 'rightAuth'
            } else {
                type = 'right'
            }

            raw_menu.forEach(el => {
                try {
                    let menu_type = el.menu_type
                    if (menu_type.includes(type)) out_menu.push(el)
                } catch { }
            })

            //сортируем меню
            out_menu.sort(function (a, b) {
                return a.sort - b.sort
            })

            return out_menu
        },
        checkPWA() {
            return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
            // return true
        }
    },
    methods: {
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        sendSocket(){
            // this.$socket.emit('my message', 'PING!') 
        },
        ...mapActions(['ActionWebAppTgLogin', 'ActionGetAllWallets', 'ActionGetAdminWallets', 'ActionGetUser', 'ActionGetSettings']),
        async loginWithTelegram(user, ref_code=null){
            this.loadAuth = true
            this.event.send('authDo')
            const ref_store = this.$store.getters.StateRef
            const ref_cookie = this.cookies.cookies.get("ref")
            const ref_localstorage = localStorage.getItem('ref')
            const ref = (ref_code) ? ref_code : (ref_store) ? ref_store : (ref_cookie) ? ref_cookie : (ref_localstorage) ? ref_localstorage : null

            try {
                const login = await this.ActionWebAppTgLogin({user: user, ref: ref}).then(res=>res)
                if(login.result && login.data){
                    this.event.send('authSuccess')
                    this.loadAuth = false

                    try { await this.ActionGetAllWallets().then(() => {})
                    } catch { console.log('error ActionGetAllWallets')}
                } else {
                    this.loadAuth = false
                    if(login.errors) {
                        for (let i = 0; i < login.errors.length; i++) {
                            this.showMess('error', 'Error', login.errors[i])
                        }
                    } else {
                        this.showMess('error', 'Error', 'Authorisation Error 1')
                    }
                }
            } catch (error) {
                console.log('error', error)
                this.showMess('error', 'Error', 'Authorisation Error 2')
                this.loadAuth = false
            }
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        menuLeftDyn() {
            let raw_menu = this.$router.options.routes,
                menu = []

            raw_menu.forEach(el => {
                let checkAuth = true,
                    checkAdmin = false,
                    checkMerchant = false,
                    checkBill = false,
                    checkManager = false,
                    checkToken = this.isLoggedIn,
                    menu_icon = null,
                    menu_type, menu_parent = '', menu_level = 1,
                    name = el.name, label = el.name, sort = 999, active = false

                try {
                    checkAuth = el.meta.requiresAuth
                } catch { }

                try {
                    checkBill = el.meta.isBillGroup
                } catch { }

                try {
                    checkManager = el.meta.requiresManager
                } catch { }

                try {
                    checkAdmin = el.meta.requiresAdmin
                } catch { }

                try {
                    checkMerchant = el.meta.requiresMerchant
                } catch { }

                try {
                    menu_type = el.menu_type
                } catch { }

                try {
                    menu_icon = (el.icon) ? el.icon : null
                } catch { }

                try {
                    menu_level = (el.menu_level) ? el.menu_level : 1
                } catch { }

                try {
                    menu_parent = (el.menu_parent) ? el.menu_parent: ''
                } catch { }

                try {
                    label =  (this.local =='ru') ?  el.name_ru :  el.name
                } catch { }

                try {
                    sort = (el.sort) ? el.sort : 999
                } catch { }

                if (el.name == this.$route.name) active = true

                let item = {
                    name: name,
                    label: label,
                    to: el.path,
                    visible: false,
                    menu_type: menu_type,
                    menu_level: menu_level,
                    menu_parent: menu_parent,
                    menu_icon: menu_icon,
                    sort: sort,
                    isActive: active,
                    isExactActive: active,
                    isNewTab: (el.meta && el.meta.isNewTab) ? true : false
                }

                // если требуется авторизация
                if(checkAuth && !this.isLoggedIn) return

                if(checkBill && !this.isUserInGroup('bill')) return

                if(checkMerchant && (!this.isUserInGroup('merchant') && !this.isUserInGroup('admin')) ) return

                if(checkManager && (!this.isUserInGroup('manager') && !this.isUserInGroup('admin')) ) return

                if(checkAdmin && !this.isUserInGroup('admin')) return

                item.visible = true
                menu.push(item)
            })

            return menu
        },
        // left | leftAuth
        menuLeft(type) {
            let raw_menu = this.menuLeftDyn(),
                out_menu_first = [],
                out_menu_second = []
                
            raw_menu.forEach(el => {
                try {
                    if (el.menu_type.includes(type)){
                        if(el.menu_level==1){
                            out_menu_first.push(el)
                        }
                        if(el.menu_level==2){
                            out_menu_second.push(el)
                        }
                    }
                } catch { }
            })

            //сортируем меню
            out_menu_first.sort(function (a, b) {
                return a.sort - b.sort
            })

            out_menu_second.sort(function (a, b) {
                return a.sort - b.sort
            })

            //добавляем вложенные пункты
            out_menu_first.forEach(el => {
                out_menu_second.forEach(el2 => {
                    if(el2.menu_parent == el.name){
                        if(!el.items)
                        el.items = []
                        el.items.push(el2)
                    }
                })
            })
            return out_menu_first
        },
    },

    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event(this)

        // загружаем справочные данные в store
        try { await PaymentSystemList.FetchFromApi(this.$store).then(() => {}) }
        catch { console.log('error store get payment data') }

        try { await BankList.FetchFromApi(this.$store).then(() => {}) }
        catch { console.log('error store get banks')}

        try { await CurrencyList.FetchFromApi(this.$store).then(() => {}) } 
        catch { console.log('error store get currencies') }

        try { await this.$store.dispatch('GetCountries').then(() => {}) }
        catch { console.log('error store get countries') }

        // прослушиваем события сокета по ключу toast_msg
        try {
            this.$socket.on('toast_msg', (data) => {
                this.showMess(data.type, data.title, data.txt)
            })
        } catch (e) {
            console.log('error socket', e)
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    async mounted() {
        this.vue_mode = (process.env.VUE_APP_MODE == 'production') ? 'production' : 'development'

        try{
            // сначала пробуем получить clientID из куки _ym_uid
            const ymUidMatch = (document && document.cookie) ? document.cookie.match(/(?:^|; )_ym_uid=([^;]+)/) : null
            const ymUid = ymUidMatch ? decodeURIComponent(ymUidMatch[1]) : null
            if (ymUid) {
                try { await this.$store.dispatch('SetYandexClientId', ymUid).then(() => {}) } catch {}
            } else {
                // фолбэк: получаем через плагин, когда счетчик готов
                if (this.$yandexMetrika && typeof this.$yandexMetrika.getClientID === 'function') {
                    this.$yandexMetrika.getClientID(async (clientId) => {
                        console.log('yandexClientId', clientId)
                        try { await this.$store.dispatch('SetYandexClientId', clientId).then(() => {}) } catch {}
                    })
                } else {
                    console.log('yandexMetrika not ready or missing')
                }
            }
        } catch (e) {
            console.log('error metrika get client id', e)
        }

        try{
            const isDarkTheme = this.$store.getters.StateDarkTheme
            if(isDarkTheme) document.documentElement.classList.toggle('p-app-dark')
        } catch {}

        // is PWA
        if (this.checkPWA) try { await this.$store.dispatch('setPWA', true).then(() => {}) } catch {}
        
        try{
            window.Telegram.WebApp.expand();
            window.Telegram.WebApp.enableClosingConfirmation();
            window.Telegram.WebApp.disableVerticalSwipes();
            window.Telegram.WebApp.BackButton.hide();
        } catch(e){}

        // читаем store, cookie, localstorage на наличие utm меток
        const utm_store = this.$store.getters.StateUtm
        const utm_cookie = this.cookies.cookies.get("utm")
        const utm_localstorage = JSON.parse(localStorage.getItem('utm'))

        if(!utm_store && !utm_cookie && !utm_localstorage){
            const utm = this.helper.get_utm()
            if (utm) {
                this.cookies.cookies.set("utm", JSON.stringify(utm))
                localStorage.setItem('utm', JSON.stringify(utm))
                try{
                    await this.$store.dispatch('SetUtm', utm).then(() => {})
                } catch {}
            }
        }

        // читаем store, cookie, localstorage на наличие ref меток
        const ref_store = this.$store.getters.StateRef
        const ref_cookie = this.cookies.cookies.get("ref")
        const ref_localstorage = localStorage.getItem('ref')

        if(!ref_store && !ref_cookie && !ref_localstorage){
            const ref = this.helper.get_ref()
            if(ref){
                this.cookies.cookies.set("ref", ref)
                localStorage.setItem('ref', ref)
                try{
                    await this.$store.dispatch('SetRef', ref).then(() => {})
                } catch {}
            }
        }

        // проверяем метку в url (/ref/code/)
        const path = (window.location.pathname) ? window.location.pathname : null

        if(path && (typeof(path)=='string') && path.length>0){
            const arPath = path.split('/')
            if(arPath && arPath.length>0){
                const codePath = (arPath[1]) ? arPath[1] : null
                const valuePath = (arPath[2]) ? arPath[2] : null
                if(codePath && (typeof(codePath)=='string') && codePath=='ref' && valuePath && (typeof(valuePath)=='string') && valuePath.length>0){
                    // записываем в store, cookie, localstorage
                    this.cookies.cookies.set("ref", valuePath)
                    localStorage.setItem('ref', valuePath)
                    try{
                        await this.$store.dispatch('SetRef', valuePath).then(() => {})
                    } catch { }
                }
            }
        }

        // проверяем смотрел ли видео
        const saw_video_store = this.$store.getters.StateHintToCreateTransfer
        const saw_video_cookie = this.cookies.cookies.get("saw_video_howToCreateTransfer")
        const saw_video_localstorage = localStorage.getItem('saw_video_howToCreateTransfer')

        // если смотрел, то вписываем в store, cookie, localstorage
        if(saw_video_store || saw_video_cookie || saw_video_localstorage){
            this.cookies.cookies.set("saw_video_howToCreateTransfer", true)
            localStorage.setItem('saw_video_howToCreateTransfer', true)
            try{
                await this.$store.dispatch('sawHowToCreateTr', true).then(() => {})
            } catch {}
        }

        // проверяем на visitorId повторно
        const visitorId_store = this.$store.getters.StateUserVisitorId
        const visitorId_cookie = this.cookies.cookies.get("visitorId")
        const visitorId_localstorage = localStorage.getItem('visitorId')

        // если есть, то вписываем в store, cookie, localstorage
        if(visitorId_store || visitorId_cookie || visitorId_localstorage){
            let visitorId = (visitorId_store) ? visitorId_store : (visitorId_cookie) ? visitorId_cookie : visitorId_localstorage
            this.cookies.cookies.set("visitorId", visitorId)
            localStorage.setItem('visitorId', visitorId)
            
            try{
                await this.$store.dispatch('setVisitorId', visitorId).then(() => {})
            } catch {}
        }

        // Получение настроек
        try { await this.$store.dispatch('ActionGetSettings').then(() => {})
        } catch { console.log('error store get settings')}

        this.initData = window.Telegram.WebApp.initData
        this.initDataUnsafe = window.Telegram.WebApp.initDataUnsafe

        if(this.initData){
            try{
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = '/css/tg.css';
                document.head.appendChild(link);
            } catch {
                console.log('error add css')
            }

            window.Telegram.WebApp.BackButton.onClick(function() {
                try { if(history) history.back() } 
                catch (e) { this.$router.push({ path: '/' }) }
            })

            // detect language_code of tg mini app
            if(this.$store.getters.StateLang) this.$i18n.locale = this.$store.getters.StateLang
            else {
                try {
                    let language_code = (this.initDataUnsafe && this.initDataUnsafe.user && this.initDataUnsafe.user.language_code) ? this.initDataUnsafe.user.language_code : 'ru'
                    if(language_code!= 'ru' && language_code != 'en') language_code = 'en'
                    this.$i18n.locale = language_code
                    this.$store.dispatch('SetLang', language_code).then(() => {}) 
                } catch (e) {
                    const msg= e.message || 'Error setting language'
                }
            }

            try{
                await this.$store.dispatch('setTgApp', true).then(() => {}) 
                await this.$store.dispatch('setPWA', false).then(() => {})
            } catch {}
            const start_param = this.helper.splitTgData(this.initData, 'start_param')
            let arParam = null
            if(start_param) arParam = this.helper.splitParams(start_param)
            let ref_code = null

            // если пришел с параметром ref в telegram app, то сохраняем его в store, cookie, localstorage
            if(arParam){
                // ref
                if(arParam['key']=='ref'){
                    const ref = arParam['value']
                    ref_code = ref
                    
                    if(!ref_localstorage) localStorage.setItem('ref', ref)
                    if(!ref_cookie) this.cookies.cookies.set("ref", ref)
                    if(!ref_store){
                        try{
                            await this.$store.dispatch('SetRef', ref).then(() => {})
                        } catch {}
                    }
                }
                // bill
                if(arParam['key']=='bill'){
                    if(arParam['value']){
                        const bill_path = '/bill/' + arParam['value']
                        this.$router.push({path: bill_path})
                    }
                }
            }

            // если нет параметра ref, то смотрим в store, cookie, localstorage
            if(!ref_code) {
                const ref_store = this.$store.getters.StateRef
                const ref_cookie = this.cookies.cookies.get("ref")
                const ref_localstorage = localStorage.getItem('ref')
                ref_code = (ref_store) ? ref_store : (ref_cookie) ? ref_cookie : (ref_localstorage) ? ref_localstorage : null
            }

            // авторизуем пользователя в telegram app
            if(!this.isLoggedIn) this.loginWithTelegram(this.initData, ref_code)

            try {
                TelegramAnalytics.init({
                    token: 'eyJhcHBfbmFtZSI6InB3X29yaWdpbl9ib3QiLCJhcHBfdXJsIjoiaHR0cHM6Ly90Lm1lL3B3X29yaWdpbl9ib3QiLCJhcHBfZG9tYWluIjoiaHR0cHM6Ly9wYXktd2F2ZS5jby8ifQ==!AVKcpf7wa0XcXH+uy9uvNPZK7l+Yep60t7QdfMuAT34=',
                    appName: 'pw_origin_bot',
                });
            } catch(e) {
                console.log('error tg analytics', e)
            }
        } else {
            try{
                await this.$store.dispatch('setTgApp', false).then(() => {})
            } catch {}

            // set lang from store
            if(this.$store.getters.StateLang) this.$i18n.locale = this.$store.getters.StateLang
        }

        // обновляем данные пользователя и продукты
        if(this.isLoggedIn){
            try { await this.$store.dispatch('ActionGetUser').then(() => {})
            } catch { console.log('error store get user')}

            try { await this.$store.dispatch('ActionGetAllWallets').then(() => {})
            } catch { console.log('error store get wallets')}

            try { await RecipientList.FetchFromApi(this.$store).then(() => {}) }
            catch { console.log('error store get recipients') }

            if(this.isUserInGroup('admin')){
                try { await this.$store.dispatch('ActionGetAdminWallets').then(() => {})
                } catch { console.log('error store get wallets')}
            }
        }
    },
}
</script>